import { render, staticRenderFns } from "./Parkinson.vue?vue&type=template&id=2339b3e6&scoped=true"
var script = {}
import style0 from "./Parkinson.vue?vue&type=style&index=0&id=2339b3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2339b3e6",
  null
  
)

export default component.exports